import { useContext } from 'react';
import * as R from 'ramda';

import { hasRolePermissions, ROLE_SETS } from '@atom/utilities/authUtilities';
import { numberToLocaleString } from '@atom/utilities/currencyUtility';
import {
  getLocalDisplayDate,
  getUtcDisplayDate,
  setDisplayDate,
  setDurationDisplay,
  setWorkTimeDisplay,
} from '@atom/utilities/timeUtilities';

import WorkOrderContext from '../WorkOrderContext';

import classes from './workOrderInfo.module.css';

const DetailPane = () => {
  const { workOrderDetail } = useContext(WorkOrderContext);
  const workTemplateFolderPath = workOrderDetail.workTemplateFolderPath
    .map(path => path.name)
    .join(' / ');

  const showActualCost = hasRolePermissions(ROLE_SETS.MANAGER);

  return (
    <>
      <div className={classes.sectionHeader}>
        <div>Details</div>
      </div>
      <div className={classes.detailContent}>
        <div className={classes.infoRow}>
          <div className={classes.rowLabel}>Work Template:</div>
          <div>{workOrderDetail.workTemplateName || '-'}</div>
        </div>
        <div className={classes.infoRow}>
          <div className={classes.rowLabel}>Work Template Folder:</div>
          <div className={classes.infoValue}>
            {workTemplateFolderPath || '-'}
          </div>
        </div>
        <div className={classes.infoRow}>
          <div className={classes.rowLabel}>Created Date:</div>
          <div>
            <div>{getUtcDisplayDate(workOrderDetail.createdDate)}</div>
            <div className={classes.localDisplayDate}>
              {getLocalDisplayDate(workOrderDetail.createdDate)}
            </div>
          </div>
        </div>
        <div className={classes.infoRow}>
          <div className={classes.rowLabel}>Created By:</div>
          <div>{workOrderDetail.createdByName || '-'}</div>
        </div>
        <div className={classes.infoRow}>
          <div className={classes.rowLabel}>Team Lead:</div>
          <div>{workOrderDetail.leadAssigneeName || '-'}</div>
        </div>
        {workOrderDetail?.appointmentsEnabled && (
          <div className={classes.infoRow}>
            <div className={classes.rowLabel}>Planned Start Date:</div>
            <div>
              <div>{getUtcDisplayDate(workOrderDetail.plannedStartDate)}</div>
              <div className={classes.localDisplayDate}>
                {getLocalDisplayDate(workOrderDetail.plannedStartDate)}
              </div>
            </div>
          </div>
        )}
        {workOrderDetail?.appointmentsEnabled ? (
          <div className={classes.infoRow}>
            <div className={classes.rowLabel}>Due Date:</div>
            <div>
              <div>{getUtcDisplayDate(workOrderDetail.dueDate)}</div>
              <div className={classes.localDisplayDate}>
                {getLocalDisplayDate(workOrderDetail.dueDate)}
              </div>
            </div>
          </div>
        ) : (
          <div className={classes.infoRow}>
            <div className={classes.rowLabel}>Due Date:</div>
            <div>{setDisplayDate(workOrderDetail.dueDate)}</div>
          </div>
        )}
        <div className={classes.infoRow}>
          <div className={classes.rowLabel}>Start Date:</div>
          <div>{setDisplayDate(workOrderDetail.startTime)}</div>
        </div>
        <div className={classes.infoRow}>
          <div className={classes.rowLabel}>Completed Date:</div>
          <div>
            <div>{getUtcDisplayDate(workOrderDetail.completionDate)}</div>
            <div className={classes.localDisplayDate}>
              {getLocalDisplayDate(workOrderDetail.completionDate)}
            </div>
          </div>
        </div>
        <div className={classes.infoRow}>
          <div className={classes.rowLabel}>Completed By:</div>
          <div>{workOrderDetail.completedByName || '-'}</div>
        </div>
        <div className={classes.infoRow}>
          <div className={classes.rowLabel}>Work Time:</div>
          <div>{setWorkTimeDisplay(workOrderDetail.workTime)}</div>
        </div>
        <div className={classes.infoRow}>
          <div className={classes.rowLabel}>Duration:</div>
          <div>{setDurationDisplay(workOrderDetail.duration)}</div>
        </div>
        <div className={classes.infoRow}>
          <div className={classes.rowLabel}>Estimated Cost:</div>
          <div>{numberToLocaleString(workOrderDetail.estimatedCost)}</div>
        </div>
        {showActualCost && (
          <div className={classes.infoRow}>
            <div className={classes.rowLabel}>Actual Cost:</div>
            <div>{numberToLocaleString(workOrderDetail.actualCost)}</div>
          </div>
        )}
        <div className={classes.infoRow}>
          <div className={classes.rowLabel}>Closed Date:</div>
          <div>
            <div>{getUtcDisplayDate(workOrderDetail.closedDate)}</div>
            <div className={classes.localDisplayDate}>
              {getLocalDisplayDate(workOrderDetail.closedDate)}
            </div>
          </div>
        </div>
        <div className={classes.infoRow}>
          <div className={classes.rowLabel}>Closed By:</div>
          <div>{workOrderDetail.closedByName || '-'}</div>
        </div>
        {!R.isEmpty(workOrderDetail.inventoryAssetId) && (
          <>
            <div className={classes.infoRow}>
              <div className={classes.rowLabel}>Inventory Update Date:</div>
              <div>
                <div>{getUtcDisplayDate(workOrderDetail.appliedDate)}</div>
                <div className={classes.localDisplayDate}>
                  {getLocalDisplayDate(workOrderDetail.appliedDate)}
                </div>
              </div>
            </div>
            <div className={classes.infoRow}>
              <div className={classes.rowLabel}>Updated By:</div>
              <div>{workOrderDetail.appliedByName || '-'}</div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default DetailPane;
